import { ReactElement, Suspense } from "react";
import { Spinner } from "@fluentui/react-components";

const LazyWrapper = ({ component }: { component: ReactElement }) => (
  <Suspense fallback={<Spinner />}>{component}</Suspense>
);

export default LazyWrapper;